<template>
  <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded wet-signature">
    <br />
    <div class="col-12 col-md-6">
      <!-- <h4>Congratulations {{ entityDetails ? entityDetails.entityName : '' }} your application has been approved.</h4> -->
      <h4>Congratulations! Now that your credit application has been approved, you need to review and sign the lease documentation.</h4>

      <p>How to proceed:</p>
      <ol>
        <li>Email or download the below documents straight to your device.</li>
        <li>Print and sign documents along with any other signatories required.</li>
        <li>Once completed, please log back in and upload the signed documents.</li>
      </ol>
    </div>
    <div class="col-12 col-md-6">
      <div class="toggle_section" v-bind:class="!enableDownload ? 'inactive' : ''">
        <div class="toggle_header" v-on:click="enableDownload = !enableDownload">
          <img
            v-bind:src="enableDownload ? '/assets/icons/open.svg' : '/assets/icons/closed.svg'"
            v-bind:class="enableDownload ? 'open' : 'closed'"
          />
          <h5>Lease Documents</h5>
        </div>
        <div class="toggle_content" v-if="enableDownload">
          <DocumentDownload
            v-if="isWetSignature"
            text="Document Instructions"
            :wetSignatureObjName="isMMBA ? 'documentAI_MMBA' : 'documentAI'"
            :loadingDownloadProp="loadingDocumentInstructionDownload"
            :loadingSendEmailProp="loadingDocumentInstructionSendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            :enableDisable="enableDisableWSMix"
          />
          <DocumentDownload
            :text="region == 'NZ' ? 'Motor Vehicle Leasing Terms & Conditions' : 'Master Lease Agreement'"
            wetSignatureObjName="documentMLA"
            :loadingDownloadProp="loadingDocumentMLADownload"
            :loadingSendEmailProp="loadingDocumentMLASendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            :enableDisable="enableDisableWSMix"
          />
          <DocumentDownload
            :text="region == 'NZ' ? 'Deed of Guarantee & Indemnity' : 'Personal Guarantee'"
            wetSignatureObjName="documentPCA"
            :loadingDownloadProp="loadingDocumentPCADownload"
            :loadingSendEmailProp="loadingDocumentPCASendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            v-if="hasPersonalGuarantee"
            :enableDisable="enableDisableWSMix"
          ></DocumentDownload>
          <DocumentDownload
            text="Direct Debit"
            wetSignatureObjName="documentBank"
            :loadingDownloadProp="loadingDocumentBankDownload"
            :loadingSendEmailProp="loadingDocumentBankSendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            :enableDisable="enableDisableWSMix"
          ></DocumentDownload>
          <DocumentDownload
            v-if="region == 'AU'"
            text="Quote"
            wetSignatureObjName="documentQuote"
            :loadingDownloadProp="loadingDocumentQuoteDownload"
            :loadingSendEmailProp="loadingDocumentQuoteSendEmail"
            @onClickDownload="onClickDownloadWSMix"
            @onClickSendEmail="onClickSendEmailWSMix"
            :enableDisable="enableDisableWSMix"
          ></DocumentDownload>
          <QBtn
            outline
            color="primary full-width"
            no-caps
            @click="onDownloadAll"
            :loading="loadingDocumentAllDownload"
            :disable="enableDisableWSMix"
            >Download All</QBtn
          >
          <QBtn
            outline
            color="primary full-width"
            no-caps
            v-on:click="
              show = !show;
              sendButtonTxt = 'Send';
            "
            >Email All</QBtn
          >
          <div class="download_email" v-if="show">
            <QForm @submit.prevent="onSendAll">
              <div class="row">
                <div class="col-8">
                  <QInput
                    ref="field"
                    outlined
                    v-model="emailAll"
                    placeholder="email"
                    :rules="getRulesWSMix()"
                    type="email"
                    v-on:blur="onBlurWSMix()"
                    lazy-rules
                  />
                </div>
                <div class="col-4">
                  <QBtn
                    outline
                    color="primary"
                    class="full-width"
                    type="submit"
                    no-caps
                    :loading="loadingDocumentSendAllSendEmail"
                    :disable="enableDisableWSMix"
                    >{{ sendButtonTxt }}</QBtn
                  >
                </div>
              </div>
            </QForm>
          </div>
        </div>
      </div>
      <div class="toggle_section" v-bind:class="!enableUpload ? 'inactive' : ''">
        <div class="toggle_header" v-on:click="enableUpload = !enableUpload">
          <img
            v-bind:src="enableUpload ? '/assets/icons/open.svg' : '/assets/icons/closed.svg'"
            v-bind:class="enableUpload ? 'open' : 'closed'"
          />
          <h5>Upload Signed Documents</h5>
        </div>
        <div class="toggle_content" v-if="enableUpload">
          <p>Please upload signed documents</p>
          <div class="row">
            <div class="col-6">
              <DocumentUpload
                :text="region == 'NZ' ? 'Motor Vehicle Leasing Terms & Conditions' : 'Master Lease Agreement'"
                wetSignatureObjName="documentMLA"
                @onClickDelete="onClickDeleteWSMix"
                :loadingDeleteProp="loadingDocumentMLADelete"
                :applicationId="vehicleApplication ? vehicleApplication.applicationId : ''"
                :isSubmitted="isSubmitted"
              ></DocumentUpload>
            </div>
            <div class="col-6" v-if="hasPersonalGuarantee">
              <DocumentUpload
                :text="region == 'NZ' ? 'Deed of Guarantee & Indemnity' : 'Personal Guarantee'"
                wetSignatureObjName="documentPCA"
                @onClickDelete="onClickDeleteWSMix"
                :loadingDeleteProp="loadingDocumentPCADelete"
                :applicationId="vehicleApplication ? vehicleApplication.applicationId : ''"
                :isSubmitted="isSubmitted"
              ></DocumentUpload>
            </div>
            <div class="col-6">
              <DocumentUpload
                text="Direct Debit"
                wetSignatureObjName="documentBank"
                @onClickDelete="onClickDeleteWSMix"
                :loadingDeleteProp="loadingDocumentBankDelete"
                :applicationId="vehicleApplication ? vehicleApplication.applicationId : ''"
                :isSubmitted="isSubmitted"
              ></DocumentUpload>
            </div>
            <div class="col-6">
              <DocumentUpload
                v-if="region == 'AU'"
                text="Quote"
                wetSignatureObjName="documentQuote"
                @onClickDelete="onClickDeleteWSMix"
                :loadingDeleteProp="loadingDocumentQuoteDelete"
                :applicationId="vehicleApplication ? vehicleApplication.applicationId : ''"
                :isSubmitted="isSubmitted"
              ></DocumentUpload>
            </div>
          </div>
          <br />
          <QBtn v-if="isSubmitted" color="primary full-width" no-caps :disable="true"> Documents Submited </QBtn>
          <QBtn v-else color="primary full-width" no-caps :disable="!enableSubmit" :loading="loadingSubmit" @click="onSubmit">
            Submit & Complete</QBtn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QForm, QInput } from 'quasar';
import { mapGetters, mapState, mapActions } from 'vuex';
import DocumentDownload from '../../components/Atoms/DocumentDownload';
import DocumentUpload from '../../components/Atoms/DocumentUpload';
import WetSignatureMixins from '../../mixins/WetSignatureMixins.js';
import MyCustomFunctions from '../../mixins/MyCustomFunctions.js';
import MutateSubmitWetSignature from '../../graphql/mutations/MutateSubmitWetSignature';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';

export default {
  name: 'WetSignature',
  components: { QBtn, QForm, QInput, DocumentDownload, DocumentUpload },
  mixins: [WetSignatureMixins, MyCustomFunctions],
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      vehicleApplication: (state) => state.vehicleApplication.vehicleApplication
    }),
    ...mapGetters({
      whiteLabel: 'theme/getWhitelabel',
      isWetSignature: 'vehicleApplication/isWetSignature'
    }),
    entityDetails() {
      return this.scoreboard?.entityDetails ? this.scoreboard?.entityDetails : null;
    },
    hasPersonalGuarantee() {
      if (
        this.scoreboard &&
        this.scoreboard.businessDetails &&
        this.scoreboard.businessDetails.financeDetails &&
        this.scoreboard.businessDetails.financeDetails.personalGuarantee === 'yes'
      )
        return true;
      else return false;
    },
    isSubmitted() {
      if (this.scoreboard.wetSignature && this.scoreboard.wetSignature.status === 'completed') return true;
      else return false;
    },
    enableSubmit() {
      const includeQuote =
        this.region == 'AU'
          ? this.scoreboard.wetSignature.documentQuote &&
            this.scoreboard.wetSignature.documentQuote.uploadFile &&
            this.scoreboard.wetSignature.documentQuote.uploadFile.uuid
          : true;

      if (
        this.hasPersonalGuarantee &&
        this.scoreboard.wetSignature &&
        this.scoreboard.wetSignature.documentMLA &&
        this.scoreboard.wetSignature.documentMLA.uploadFile &&
        this.scoreboard.wetSignature.documentMLA.uploadFile.uuid &&
        this.scoreboard.wetSignature.documentPCA &&
        this.scoreboard.wetSignature.documentPCA.uploadFile &&
        this.scoreboard.wetSignature.documentPCA.uploadFile.uuid &&
        this.scoreboard.wetSignature.documentBank &&
        this.scoreboard.wetSignature.documentBank.uploadFile &&
        this.scoreboard.wetSignature.documentBank.uploadFile.uuid &&
        includeQuote
      )
        return true;
      else if (
        !this.hasPersonalGuarantee &&
        this.scoreboard.wetSignature &&
        this.scoreboard.wetSignature.documentMLA &&
        this.scoreboard.wetSignature.documentMLA.uploadFile &&
        this.scoreboard.wetSignature.documentMLA.uploadFile.uuid &&
        this.scoreboard.wetSignature.documentBank &&
        this.scoreboard.wetSignature.documentBank.uploadFile &&
        this.scoreboard.wetSignature.documentBank.uploadFile.uuid &&
        this.scoreboard.wetSignature.documentQuote &&
        this.scoreboard.wetSignature.documentQuote.uploadFile &&
        this.scoreboard.wetSignature.documentQuote.uploadFile.uuid
      )
        return true;
      else return false;
    },
    isMMBA() {
      if (this.whiteLabel?.abn === '53007870395' || this.whiteLabel?.introducer?.abn === '53007870395') {
        return true;
      }
      return false;
    },
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    }
  },
  data: function () {
    return {
      loadingSubmit: false,
      enableDownload: true,
      enableUpload: true,
      sendButtonTxt: 'Send',
      show: false,
      emailAll: ''
    };
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    onSendAll: async function () {
      if (this.emailAll) {
        await this.onClickSendEmailWSMix('send-all', this.emailAll);
        this.sendButtonTxt = 'Sent';
      }
    },
    onDownloadAll: async function () {
      await this.onClickDownloadWSMix('download-all');
    },
    onSubmit: async function () {
      const wetSignatureStatus = 'completed';
      this.loadingSubmit = true;
      await this.$apollo
        .mutate({
          mutation: MutateSubmitWetSignature,
          variables: {
            applicationId: this.vehicleApplication.applicationId,
            status: wetSignatureStatus
          }
        })
        .then(async (data) => {
          if (data && data.data && data.data.submitWetSignature && data.data.submitWetSignature.url) {
            let self = this;
            setTimeout(function () {
              self.updateVehicleApplicationState({
                value: wetSignatureStatus,
                propertyFirst: 'wetSignature',
                propertySecond: 'status'
              });
            });
            await this.updateVehicleApplication('finished', 'status');

            this.$router.push({ name: 'applications', params: { applicationId: this.vehicleApplication.applicationId } });
          }
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingSubmit = false;
    }
  }
};
</script>
